import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export default function Profile() {
  const { api, user } = useAuth();
  const toast = useToast();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');

  const change = async () => {
    try {
      await api('/auth/password', { method: 'PUT', body: JSON.stringify({ current, newPassword: next }) });
      toast.success('تم تغيير كلمة المرور');
      setCurrent(''); setNext('');
    } catch (e) { toast.error(e.message); }
  };

  return (
    <div>
      <h2 style={{ marginBottom: 20 }}>👤 ملفّي</h2>
      <div className="card" style={{ marginBottom: 20 }}>
        <div><strong>{user?.name}</strong></div>
        <div style={{ direction: 'ltr', color: 'var(--text-muted)' }}>{user?.email}</div>
        <div style={{ marginTop: 6, fontSize: 13 }}>الدور: <strong>{user?.role}</strong></div>
      </div>
      <div className="card">
        <div className="card-title" style={{ marginBottom: 12 }}>تغيير كلمة المرور</div>
        <div style={{ display: 'grid', gap: 12, maxWidth: 400 }}>
          <input className="form-input" type="password" placeholder="كلمة المرور الحالية" value={current} onChange={e => setCurrent(e.target.value)}/>
          <input className="form-input" type="password" placeholder="كلمة المرور الجديدة" value={next} onChange={e => setNext(e.target.value)}/>
          <button className="btn btn-primary" onClick={change} disabled={!current || next.length < 6}>تغيير</button>
        </div>
      </div>
    </div>
  );
}
